/* QOWAA FIT — theme behaviors
   Sticky header, FAQ accordion, footer accordion, packs IntersectionObserver, newsletter feedback
*/
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function initStickyHeader() {
    const header = document.querySelector('[data-qw-header]');
    if (!header) return;
    let ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        header.classList.toggle('is-scrolled', window.scrollY > 100);
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Top bar annonces : fermeture (localStorage 7j) + rotation des messages (5s)
  function initTopBar() {
    const bar = document.querySelector('[data-qw-topbar]');
    if (!bar) return;
    const KEY = 'qowaa_topbar_dismissed';
    try { const t = parseInt(localStorage.getItem(KEY), 10); if (t && Date.now() < t) { bar.hidden = true; return; } } catch (e) {}
    const close = bar.querySelector('[data-qw-topbar-close]');
    if (close) close.addEventListener('click', function () {
      bar.hidden = true;
      try { localStorage.setItem(KEY, String(Date.now() + 7 * 24 * 3600 * 1000)); } catch (e) {}
    });
    const msgs = bar.querySelectorAll('[data-qw-topbar-msg]');
    if (msgs.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      let i = 0;
      setInterval(function () {
        msgs[i].classList.remove('is-active');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-active');
      }, 5000);
    }
  }

  function initFaqAccordion() {
    document.querySelectorAll('[data-qw-faq]').forEach((list) => {
      const items = list.querySelectorAll('.faq__item');
      items.forEach((item, idx) => {
        const btn = item.querySelector('.faq__q');
        if (!btn) return;
        btn.addEventListener('click', () => {
          const isOpen = item.classList.contains('is-open');
          items.forEach((i) => i.classList.remove('is-open'));
          if (!isOpen) item.classList.add('is-open');
          items.forEach((i) => {
            const b = i.querySelector('.faq__q');
            if (b) b.setAttribute('aria-expanded', i.classList.contains('is-open') ? 'true' : 'false');
          });
        });
      });
      if (items[0]) items[0].classList.add('is-open');
    });
  }

  function initFooterAccordion() {
    if (window.matchMedia('(min-width: 960px)').matches) return;
    document.querySelectorAll('.footer__col-head').forEach((head) => {
      head.addEventListener('click', () => {
        const col = head.closest('.footer__col');
        if (!col) return;
        col.classList.toggle('is-open');
      });
    });
  }

  function initPackPills() {
    if (typeof IntersectionObserver === 'undefined') return;
    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const pills = document.querySelectorAll('.pack__save-pill');
    if (!pills.length) return;
    if (reduce) {
      pills.forEach((p) => p.classList.add('is-in'));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.3 }
    );
    pills.forEach((p) => io.observe(p));
  }

  function initNewsletter() {
    document.querySelectorAll('[data-qw-newsletter]').forEach((form) => {
      const ok = form.querySelector('[data-qw-newsletter-success]');
      const params = new URLSearchParams(window.location.search);
      if (params.get('customer_posted') === 'true' && ok) {
        ok.hidden = false;
        const body = form.querySelector('.newsletter__form');
        if (body) body.hidden = true;
      }
    });
  }

  // ───────────────────────────────────────────────
  // Judge.me API → custom QOWAA marquee
  // Fetch direct via API REST + render dans notre marquee
  // ───────────────────────────────────────────────
  function qwStarsHtml(rating) {
    const r = Math.max(0, Math.min(5, Math.round(rating)));
    let out = '<span class="stars" aria-label="' + r + ' étoiles sur 5">';
    for (let i = 1; i <= 5; i++) {
      const cls = i <= r ? 'star is-on' : 'star is-off';
      out += '<svg viewBox="0 0 24 24" width="14" height="14" class="' + cls + '" aria-hidden="true"><path d="M12 2l2.92 6.26L22 9.27l-5.5 4.74L18 22l-6-3.56L6 22l1.5-7.99L2 9.27l7.08-1.01L12 2z" fill="currentColor"/></svg>';
    }
    return out + '</span>';
  }
  function qwPad2(n) { return ('0' + n).slice(-2); }
  function qwEscapeHtml(s) {
    return (s || '').replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  function qwRenderJdgmMarquee(track, reviews, root) {
    const total = reviews.length;
    if (!total) return;
    // Stocker reviews sur root pour lookup via index (évite encodage JSON dans attributs HTML)
    if (root) root._qwReviewsData = reviews;
    const cards = [];
    // 3 passes pour boucle marquee continue + variété visuelle
    for (let pass = 1; pass <= 3; pass++) {
      reviews.forEach(function (r, i) {
        const ariaHidden = pass > 1 ? ' aria-hidden="true"' : '';
        const playBadge = r.videoId
          ? '<span class="review__play" aria-hidden="true"><svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg></span>'
          : '';
        const photo = r.image
          ? '<div class="review__photo"><img src="' + qwEscapeHtml(r.image) + '" alt="" loading="lazy">' + playBadge + '</div>'
          : '';
        const verified = r.verified
          ? '<span class="review__verified" aria-label="Avis vérifié">✓ Vérifié</span>'
          : '';
        cards.push(
          '<article class="review review--with-photo" data-qw-review-index="' + i + '" tabindex="0" role="button" aria-label="Voir l\'avis complet"' + ariaHidden + '>' +
            '<div class="review__head">' +
              qwStarsHtml(r.rating) +
              '<span class="review__num">' + qwPad2(i + 1) + ' / ' + qwPad2(total) + '</span>' +
            '</div>' +
            photo +
            '<p class="review__body">' + qwEscapeHtml(r.body) + '</p>' +
            '<span class="review__divider"></span>' +
            '<div class="review__meta">' +
              '<span class="review__author">' + qwEscapeHtml(r.author) + verified + '</span>' +
              (r.product ? '<span class="review__ctx">' + qwEscapeHtml(r.product.toUpperCase()) + '</span>' : '') +
            '</div>' +
          '</article>'
        );
      });
    }
    track.innerHTML = cards.join('');
  }

  // ───────── Modal détail avis (créée dynamiquement) ─────────
  function qwEnsureReviewModal() {
    let modal = document.getElementById('qw-review-modal-root');
    if (modal) return modal;
    modal = document.createElement('div');
    modal.id = 'qw-review-modal-root';
    modal.className = 'qw-reviews-jdgm reviews__modal';
    modal.setAttribute('hidden', '');
    modal.setAttribute('aria-hidden', 'true');
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.innerHTML =
      '<div class="reviews__modal-backdrop" data-qw-modal-close></div>' +
      '<article class="reviews__modal-card">' +
        '<button class="reviews__modal-close" type="button" data-qw-modal-close aria-label="Fermer">×</button>' +
        '<div class="reviews__modal-photo" data-qw-modal-photo></div>' +
        '<div class="reviews__modal-body-wrap">' +
          '<div class="reviews__modal-head">' +
            '<span data-qw-modal-stars></span>' +
            '<span class="review__verified" data-qw-modal-verified hidden>✓ Vérifié</span>' +
          '</div>' +
          '<p class="reviews__modal-body" data-qw-modal-body></p>' +
          '<span class="review__divider"></span>' +
          '<div class="reviews__modal-meta">' +
            '<span class="review__author" data-qw-modal-author></span>' +
            '<span class="review__ctx" data-qw-modal-product></span>' +
          '</div>' +
        '</article>' +
      '</article>';
    document.body.appendChild(modal);
    // Bind close
    modal.querySelectorAll('[data-qw-modal-close]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        qwCloseReviewModal();
      });
    });
    return modal;
  }

  function qwOpenReviewModal(root, reviewData) {
    const modal = qwEnsureReviewModal();
    const photo = modal.querySelector('[data-qw-modal-photo]');
    const stars = modal.querySelector('[data-qw-modal-stars]');
    const body = modal.querySelector('[data-qw-modal-body]');
    const author = modal.querySelector('[data-qw-modal-author]');
    const product = modal.querySelector('[data-qw-modal-product]');
    const verified = modal.querySelector('[data-qw-modal-verified]');

    if (photo) {
      if (reviewData.videoId) {
        // Vidéo d'avis hébergée par Judge.me sur Cloudflare Stream
        photo.innerHTML = '<iframe src="https://iframe.videodelivery.net/' + qwEscapeHtml(reviewData.videoId) +
          '" allow="accelerometer; gyroscope; encrypted-media; picture-in-picture" allowfullscreen loading="lazy" title="Vidéo de l\'avis"></iframe>';
        photo.classList.add('is-video');
        photo.style.display = '';
      } else {
        photo.innerHTML = reviewData.image
          ? '<img src="' + qwEscapeHtml(reviewData.image) + '" alt="">'
          : '';
        photo.classList.remove('is-video');
        photo.style.display = reviewData.image ? '' : 'none';
      }
    }
    if (stars) stars.innerHTML = qwStarsHtml(reviewData.rating);
    if (body) body.textContent = reviewData.body;
    if (author) author.textContent = reviewData.author;
    if (product) product.textContent = (reviewData.product || '').toUpperCase();
    if (verified) {
      if (reviewData.verified) verified.removeAttribute('hidden');
      else verified.setAttribute('hidden', '');
    }
    modal.removeAttribute('hidden');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function qwCloseReviewModal() {
    const modal = document.getElementById('qw-review-modal-root');
    if (!modal) return;
    // Retirer l'iframe vidéo pour couper la lecture à la fermeture
    const photo = modal.querySelector('[data-qw-modal-photo]');
    if (photo && photo.querySelector('iframe')) photo.innerHTML = '';
    modal.setAttribute('hidden', '');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function qwBindCardClicks(root) {
    // Handler au niveau document avec capture — catch les clicks même si la marquee bouge
    function handleClick(e) {
      const card = e.target.closest('[data-qw-review-index]');
      if (!card) return;
      // Vérifier que la card appartient à NOTRE section root
      if (!root.contains(card)) return;
      const idx = parseInt(card.getAttribute('data-qw-review-index'), 10);
      const data = (root._qwReviewsData || [])[idx];
      if (data) {
        e.preventDefault();
        e.stopPropagation();
        qwOpenReviewModal(root, data);
      }
    }
    function handleKey(e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      const card = e.target.closest('[data-qw-review-index]');
      if (!card || !root.contains(card)) return;
      e.preventDefault();
      const idx = parseInt(card.getAttribute('data-qw-review-index'), 10);
      const data = (root._qwReviewsData || [])[idx];
      if (data) qwOpenReviewModal(root, data);
    }

    // Capture + bubble pour être sûr
    document.addEventListener('click', handleClick, true);
    document.addEventListener('keydown', handleKey, true);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') qwCloseReviewModal();
    });
  }

  function qwUpdateJdgmScore(root, reviews) {
    const scoreBlock = root.querySelector('[data-qw-score]');
    if (!scoreBlock || !reviews.length) return;
    const sum = reviews.reduce(function (s, r) { return s + (r.rating || 0); }, 0);
    const avg = sum / reviews.length;
    const starsEl = scoreBlock.querySelector('[data-qw-stars]');
    const avgEl = scoreBlock.querySelector('[data-qw-avg]');
    const cntEl = scoreBlock.querySelector('[data-qw-count]');
    if (starsEl) starsEl.innerHTML = qwStarsHtml(Math.round(avg));
    if (avgEl) avgEl.textContent = avg.toFixed(1) + '/5';
    if (cntEl) cntEl.textContent = '· basé sur ' + reviews.length + ' avis vérifiés';
    scoreBlock.removeAttribute('hidden');
  }

  function qwFetchJudgemeReviewsFromJson(jsonUrl) {
    return fetch(jsonUrl, { method: 'GET', cache: 'no-cache' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      });
  }

  function initJdgmApiReviews() {
    const roots = document.querySelectorAll('[data-qw-reviews][data-jdgm-json]');
    roots.forEach(function (root) {
      const jsonUrl = root.getAttribute('data-jdgm-json');
      const maxReviews = parseInt(root.getAttribute('data-max-reviews') || '20', 10);
      const minRating = parseInt(root.getAttribute('data-min-rating') || '4', 10);
      const track = root.querySelector('[data-qw-track]');
      const marquee = root.querySelector('[data-qw-marquee]');
      const loading = root.querySelector('[data-qw-loading]');
      if (!jsonUrl || !track) {
        if (loading) loading.innerHTML = '<p style="text-align:center;color:var(--qw-chrome-400);font-size:12px;">Source avis manquante</p>';
        return;
      }

      qwFetchJudgemeReviewsFromJson(jsonUrl)
        .then(function (data) {
          const raw = (data && data.reviews) ? data.reviews : [];
          const reviews = raw
            .filter(function (r) {
              return r.published && !r.hidden && r.body && r.body.trim().length > 0 && (r.rating || 0) >= minRating;
            })
            .slice(0, maxReviews)
            .map(function (r) {
              const reviewer = r.reviewer || {};
              const pic = (r.pictures && r.pictures[0] && r.pictures[0].urls) ? r.pictures[0].urls : null;
              // 1. Photo d'avis HD si dispo · 2. Sinon miniature vidéo · 3. Sinon photo produit · 4. Sinon vide
              const reviewImage = pic ? (pic.huge || pic.original || pic.compact || pic.small) : '';
              const imageUrl = reviewImage || r.video_thumbnail || r.product_image || '';
              return {
                body: r.body || r.title || '',
                author: reviewer.name || 'Client',
                product: r.product_title || '',
                rating: r.rating || 5,
                image: imageUrl,
                videoId: r.video_id || '',
                verified: r.verified === 'verified' || r.curated === 'ok'
              };
            });

          if (!reviews.length) {
            if (loading) loading.innerHTML = '<p style="text-align:center;color:var(--qw-chrome-400);font-size:12px;">Aucun avis disponible pour le moment.</p>';
            return;
          }

          qwRenderJdgmMarquee(track, reviews, root);
          qwUpdateJdgmScore(root, reviews);
          qwBindCardClicks(root);
          if (marquee) marquee.removeAttribute('hidden');
          if (loading) loading.remove();
        })
        .catch(function (err) {
          if (loading) loading.innerHTML = '<p style="text-align:center;color:var(--qw-chrome-400);font-size:12px;">Erreur de chargement Judge.me API: ' + err.message + '</p>';
        });
    });
  }

  /* eslint-disable no-unused-vars */
  function _qwStarsHtmlUnused(rating) {
    const r = Math.max(0, Math.min(5, Math.round(rating)));
    let out = '<span class="stars" aria-label="' + r + ' étoiles sur 5">';
    for (let i = 1; i <= 5; i++) {
      const cls = i <= r ? 'star is-on' : 'star is-off';
      out += '<svg viewBox="0 0 24 24" width="14" height="14" class="' + cls + '" aria-hidden="true"><path d="M12 2l2.92 6.26L22 9.27l-5.5 4.74L18 22l-6-3.56L6 22l1.5-7.99L2 9.27l7.08-1.01L12 2z" fill="currentColor"/></svg>';
    }
    return out + '</span>';
  }

  function qwPad2(n) { return ('0' + n).slice(-2); }

  function qwEscapeHtml(s) {
    return (s || '').replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  function qwCountStars(el) {
    // Compte les étoiles "pleines" (avec data-score, ou via classe is-on, jdgm-star.jdgm--on)
    const score = el.getAttribute('data-score');
    if (score) return parseInt(score, 10);
    const stars = el.querySelectorAll('.jdgm-star, .star, [class*="star"]');
    let filled = 0;
    stars.forEach(function (s) {
      const cls = s.className || '';
      if (cls.indexOf('--on') >= 0 || cls.indexOf('is-on') >= 0 || cls.indexOf('--filled') >= 0 || cls.indexOf('-filled') >= 0) {
        filled++;
      }
    });
    return filled || 5;
  }

  function qwExtractCardsCarousel(root) {
    const out = [];
    const seen = new Set();

    // Approche heuristique : trouver toutes les img qui semblent être des photos d'avis,
    // puis remonter au parent qui ressemble à une card (avec texte + auteur + étoiles)
    const imgs = root.querySelectorAll('img');
    const cardCandidates = new Set();

    imgs.forEach(function (img) {
      const src = img.getAttribute('src') || '';
      // Ignorer logos, icônes, étoiles
      if (!src || src.indexOf('data:') === 0) return;
      if (src.indexOf('star') >= 0 || src.indexOf('icon') >= 0) return;
      // Remonter pour trouver le "parent card" — élément qui contient aussi du texte
      let parent = img.parentElement;
      let depth = 0;
      while (parent && depth < 8) {
        if (parent.textContent && parent.textContent.trim().length > 40) {
          cardCandidates.add(parent);
          break;
        }
        parent = parent.parentElement;
        depth++;
      }
    });

    // Fallback : si pas d'img trouvée, chercher des éléments avec étoiles et texte
    if (cardCandidates.size === 0) {
      const starGroups = root.querySelectorAll('.jdgm-stars, [class*="stars"]');
      starGroups.forEach(function (sg) {
        let parent = sg.parentElement;
        let depth = 0;
        while (parent && depth < 6) {
          if (parent.textContent && parent.textContent.trim().length > 50) {
            cardCandidates.add(parent);
            break;
          }
          parent = parent.parentElement;
          depth++;
        }
      });
    }

    function looksLikeProduct(t) {
      if (/[–—]/.test(t)) return true;
      if (/^(pack|pantacourt|t-shirt|tshirt|cache-nombril|haut|short|cuissard|qowaa)/i.test(t)) return true;
      return false;
    }

    function looksLikeAuthor(t) {
      if (t.length > 60) return false;
      if (looksLikeProduct(t)) return false;
      // Auteur typique : 1-3 mots, commence par une majuscule, lettres + espaces uniquement
      // Ex: "Nawfel", "Borz", "Ahmed", "belghazi anas", "Lotfi QORCHI"
      if (/^[A-Za-zÀ-ÿ][A-Za-zÀ-ÿ\s.'-]{1,40}$/.test(t)) return true;
      return false;
    }

    cardCandidates.forEach(function (card) {
      // Photo : 1ère img qui n'est ni étoile ni icône
      let imageSrc = '';
      card.querySelectorAll('img').forEach(function (im) {
        const s = im.getAttribute('src') || '';
        if (!s || s.indexOf('data:') === 0) return;
        if (s.indexOf('star') >= 0 || s.indexOf('icon') >= 0) return;
        if (!imageSrc) imageSrc = s;
      });

      // Étoiles
      const starsEl = card.querySelector('.jdgm-stars, [class*="stars"]');
      const rating = starsEl ? qwCountStars(starsEl) : 5;

      // Texte nodes uniques (dans l'ordre DOM)
      const seenTxt = new Set();
      const texts = [];
      const walker = document.createTreeWalker(card, NodeFilter.SHOW_TEXT, null, false);
      let n;
      while ((n = walker.nextNode())) {
        const txt = n.textContent.trim();
        if (txt.length < 2) continue;
        // Filtre étoiles unicode / chiffres seuls
        if (/^[★☆⭐\s\d.,/-]+$/.test(txt)) continue;
        if (seenTxt.has(txt)) continue;
        seenTxt.add(txt);
        texts.push(txt);
      }

      // Classification : on cherche product → author → body
      let product = '';
      let author = '';
      let body = '';

      // 1. Produit : 1er texte qui matche le pattern produit
      for (let i = 0; i < texts.length; i++) {
        if (looksLikeProduct(texts[i])) {
          product = texts[i];
          break;
        }
      }

      // 2. Auteur : 1er texte qui ressemble à un nom de personne
      for (let i = 0; i < texts.length; i++) {
        if (texts[i] === product) continue;
        if (looksLikeAuthor(texts[i])) {
          author = texts[i];
          break;
        }
      }

      // 3. Body : ce qui reste de plus long
      const remaining = texts.filter(function (t) { return t !== product && t !== author; });
      remaining.sort(function (a, b) { return b.length - a.length; });
      body = remaining[0] || '';

      // Fallback : si on a body mais pas author, prendre le 2e texte le plus court
      if (!author && remaining.length > 1) {
        const shorts = remaining.slice(1).sort(function (a, b) { return a.length - b.length; });
        author = shorts[0] || '';
      }

      if (!body || !author) return;
      const dedupKey = author + '|' + body.slice(0, 30);
      if (seen.has(dedupKey)) return;
      seen.add(dedupKey);

      // Vérifié : présence d'un badge ou texte verified/vérifié dans la card
      const cardText = card.textContent.toLowerCase();
      const verified = cardText.indexOf('verified') >= 0 || cardText.indexOf('vérifié') >= 0;

      out.push({
        body: body,
        author: author,
        product: product,
        rating: rating,
        image: imageSrc,
        verified: verified
      });
    });

    return out;
  }

  function qwRenderMarquee(track, reviews) {
    const total = reviews.length;
    if (!total) return;
    const cards = [];
    // 2 passes pour boucle infinie
    for (let pass = 1; pass <= 2; pass++) {
      reviews.forEach(function (r, i) {
        const ariaHidden = pass > 1 ? ' aria-hidden="true"' : '';
        const photo = r.image
          ? '<div class="review__photo"><img src="' + qwEscapeHtml(r.image) + '" alt="" loading="lazy"></div>'
          : '';
        const verified = r.verified
          ? '<span class="review__verified">✓ Vérifié</span>'
          : '';
        cards.push(
          '<article class="review review--with-photo"' + ariaHidden + '>' +
            '<div class="review__head">' +
              qwStarsHtml(r.rating) +
              '<span class="review__num">' + qwPad2(i + 1) + ' / ' + qwPad2(total) + '</span>' +
            '</div>' +
            photo +
            '<p class="review__body">' + qwEscapeHtml(r.body) + '</p>' +
            '<span class="review__divider"></span>' +
            '<div class="review__meta">' +
              '<span class="review__author">' + qwEscapeHtml(r.author) + verified + '</span>' +
              (r.product ? '<span class="review__ctx">' + qwEscapeHtml(r.product.toUpperCase()) + '</span>' : '') +
            '</div>' +
          '</article>'
        );
      });
    }
    track.innerHTML = cards.join('');
  }

  function qwUpdateScoreBlock(root, reviews) {
    const scoreBlock = root.querySelector('[data-qw-score]');
    if (!scoreBlock || !reviews.length) return;
    const sum = reviews.reduce(function (s, r) { return s + (r.rating || 0); }, 0);
    const avg = sum / reviews.length;
    const avgStr = avg.toFixed(1);
    const starsEl = scoreBlock.querySelector('[data-qw-stars]');
    const avgEl = scoreBlock.querySelector('[data-qw-avg]');
    const cntEl = scoreBlock.querySelector('[data-qw-count]');
    if (starsEl) starsEl.innerHTML = qwStarsHtml(Math.round(avg));
    if (avgEl) avgEl.textContent = avgStr + '/5';
    if (cntEl) cntEl.textContent = '· basé sur ' + reviews.length + ' avis vérifiés';
    scoreBlock.removeAttribute('hidden');
  }

  function initJudgemeMarquee() {
    const roots = document.querySelectorAll('[data-qw-reviews]');
    roots.forEach(function (root) {
      const source = root.querySelector('.reviews__jdgm-source');
      const track = root.querySelector('[data-qw-track]');
      const marquee = root.querySelector('[data-qw-marquee]');
      if (!source || !track) return;

      const debugEl = root.querySelector('[data-qw-debug]');
      function updateDebug(msg) {
        if (debugEl) debugEl.innerHTML = msg;
      }

      let resolved = false;
      function tryExtract() {
        if (resolved) return;
        const reviews = qwExtractCardsCarousel(source);
        // Inventaire DOM pour debug
        const swiperSlides = source.querySelectorAll('.swiper-slide').length;
        const jdgmRev = source.querySelectorAll('.jdgm-rev').length;
        const cardsCarouselSlide = source.querySelectorAll('[class*="cards-carousel__slide"]').length;
        const allClasses = new Set();
        source.querySelectorAll('*').forEach(function (el) {
          (el.className && typeof el.className === 'string' ? el.className.split(' ') : []).forEach(function (c) {
            if (c.indexOf('jdgm') === 0 || c.indexOf('cards-carousel') >= 0) allClasses.add(c);
          });
        });
        const sampleClasses = Array.from(allClasses).slice(0, 8).join(', ');
        updateDebug(
          'extracted: ' + reviews.length + ' avis | ' +
          'swiper-slide: ' + swiperSlides + ' | ' +
          'jdgm-rev: ' + jdgmRev + ' | ' +
          'cards-carousel__slide: ' + cardsCarouselSlide +
          '<br>Classes jdgm vues: ' + (sampleClasses || '(aucune)')
        );
        if (reviews.length > 0) {
          resolved = true;
          qwRenderMarquee(track, reviews);
          qwUpdateScoreBlock(root, reviews);
          if (marquee) marquee.removeAttribute('hidden');
          if (observer) observer.disconnect();
        }
      }

      let observer = null;
      if (typeof MutationObserver !== 'undefined') {
        observer = new MutationObserver(tryExtract);
        observer.observe(source, { childList: true, subtree: true });
      }

      tryExtract();
      let attempts = 0;
      (function pollTick() {
        if (resolved) return;
        attempts++;
        tryExtract();
        if (!resolved && attempts < 40) setTimeout(pollTick, 500);
        else if (!resolved && observer) observer.disconnect();
      })();
    });
  }

  // ───────────────────────────────────────────────
  // Modal "Laisser un avis" → soumet à Judge.me API
  // ───────────────────────────────────────────────
  function initReviewForm() {
    const modal = document.querySelector('[data-qw-form-modal]');
    if (!modal) return;
    const form = modal.querySelector('[data-qw-form]');
    const starsWrap = modal.querySelector('[data-qw-form-stars]');
    const stars = starsWrap ? starsWrap.querySelectorAll('.qw-form-star') : [];
    const status = modal.querySelector('[data-qw-form-status]');
    const submitBtn = modal.querySelector('[data-qw-form-submit]');
    let currentRating = 5;

    function setRating(r) {
      currentRating = r;
      stars.forEach(function (s, i) {
        s.classList.toggle('is-active', i < r);
      });
    }
    stars.forEach(function (s, i) {
      s.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        setRating(i + 1);
      });
    });
    setRating(5);

    function openModal() {
      modal.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      status.textContent = '';
      status.className = 'qw-form-status';
      submitBtn.disabled = false;
      submitBtn.textContent = 'ENVOYER L\'AVIS';
    }
    function closeModal() {
      modal.setAttribute('hidden', '');
      document.body.style.overflow = '';
    }

    // Event delegation au niveau document (capture) — marche même si le bouton est rendu après init
    document.addEventListener('click', function (e) {
      const openBtn = e.target.closest('[data-qw-open-review-form]');
      if (openBtn) {
        e.preventDefault();
        e.stopPropagation();
        openModal();
        return;
      }
      const closeBtn = e.target.closest('[data-qw-form-close]');
      if (closeBtn && modal.contains(closeBtn)) {
        e.preventDefault();
        e.stopPropagation();
        closeModal();
      }
    }, true);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hasAttribute('hidden')) closeModal();
    });

    // Submit → POST form-urlencoded vers Judge.me (no preflight, simple request)
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const root = document.querySelector('[data-qw-reviews]');
      const token = root ? root.getAttribute('data-jdgm-token') : '';
      const shop = root ? root.getAttribute('data-jdgm-shop') : '';
      if (!token) {
        status.textContent = 'Configuration manquante (token API).';
        status.classList.add('is-error');
        return;
      }

      const data = new FormData(form);
      const body = new URLSearchParams();
      body.set('api_token', token);
      body.set('shop_domain', shop || '43af51-19.myshopify.com');
      body.set('platform', 'shopify');
      body.set('name', data.get('name') || '');
      body.set('email', data.get('email') || '');
      body.set('rating', String(currentRating));
      body.set('title', data.get('title') || '');
      body.set('body', data.get('body') || '');
      body.set('product_handle', data.get('product_handle') || '');

      submitBtn.disabled = true;
      submitBtn.textContent = 'ENVOI EN COURS…';
      status.textContent = '';
      status.className = 'qw-form-status';

      fetch('https://judge.me/api/v1/reviews', {
        method: 'POST',
        mode: 'no-cors',  // simple request : pas de preflight
        body: body
      }).then(function () {
        // mode no-cors → réponse opaque, on assume succès si pas d'exception réseau
        status.textContent = '✓ Avis envoyé ! Modération sous 48h, puis publication.';
        status.classList.add('is-success');
        submitBtn.textContent = 'ENVOYÉ ✓';
        form.reset();
        setRating(5);
        setTimeout(close, 3500);
      }).catch(function () {
        status.textContent = 'Erreur réseau. Réessaie plus tard.';
        status.classList.add('is-error');
        submitBtn.disabled = false;
        submitBtn.textContent = 'ENVOYER L\'AVIS';
      });
    });
  }

  // ───────────────────────────────────────────────
  // Calcule et affiche la durée réelle de chaque reel vidéo
  // ───────────────────────────────────────────────
  function initReelsDuration() {
    document.querySelectorAll('.reel video').forEach(function (video) {
      function updateDuration() {
        const card = video.closest('.reel');
        const durationEl = card ? card.querySelector('[data-qw-duration]') : null;
        if (!durationEl || !video.duration || isNaN(video.duration)) return;
        const total = Math.round(video.duration);
        const m = Math.floor(total / 60);
        const s = total % 60;
        durationEl.textContent = m + ':' + (s < 10 ? '0' + s : s);
      }
      if (video.readyState >= 1) {
        updateDuration();
      } else {
        video.addEventListener('loadedmetadata', updateDuration, { once: true });
      }
    });
  }

  // ───────────────────────────────────────────────
  // Carrousel 3D pour les reels UGC (mode static ≤ 4 reels)
  // ───────────────────────────────────────────────
  function initReelsCarousel() {
    const rails = document.querySelectorAll('.ugc-v2__rail--static');
    rails.forEach(function (rail) {
      const reels = rail.querySelectorAll('.reel');
      const total = reels.length;
      if (total < 2) return;

      let active = Math.floor(total / 2);  // démarre la card centrale active
      function muteAll() {
        rail.querySelectorAll('video').forEach(function (v) { v.muted = true; });
        rail.querySelectorAll('[data-qw-sound-toggle]').forEach(function (b) { b.classList.remove('is-on'); });
      }
      function update() {
        reels.forEach(function (el, i) {
          el.classList.toggle('is-active', i === active);
        });
        muteAll();
      }
      update();

      // Rotation auto toutes les 4s
      let timer = setInterval(function () {
        active = (active + 1) % total;
        update();
      }, 4000);

      // Pause au hover, reprise après
      rail.addEventListener('mouseenter', function () { clearInterval(timer); });
      rail.addEventListener('mouseleave', function () {
        timer = setInterval(function () {
          active = (active + 1) % total;
          update();
        }, 4000);
      });

      // Clic sur card prev/next → la met active
      reels.forEach(function (el, i) {
        el.addEventListener('click', function (e) {
          // Ignorer si on a cliqué sur le bouton son (géré séparément)
          if (e.target.closest('[data-qw-sound-toggle]')) return;
          if (!el.classList.contains('is-active')) {
            e.preventDefault();
            active = i;
            update();
          }
        });
      });

      // Toggle son : 1 seule vidéo avec son à la fois
      rail.querySelectorAll('[data-qw-sound-toggle]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          const card = btn.closest('.reel');
          const video = card.querySelector('video');
          if (!video) return;
          if (video.muted) {
            muteAll();
            video.muted = false;
            btn.classList.add('is-on');
            video.play().catch(function () { /* autoplay policy */ });
          } else {
            video.muted = true;
            btn.classList.remove('is-on');
          }
        });
      });
    });
  }

  function initBurger() {
    const burger = document.querySelector('[data-qw-burger]');
    const drawer = document.querySelector('[data-qw-drawer]');
    if (!burger || !drawer) return;
    const closeBtn = drawer.querySelector('[data-qw-drawer-close]');
    function open() {
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      burger.setAttribute('aria-expanded', 'true');
      drawer.setAttribute('aria-hidden', 'false');
    }
    function close() {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
      burger.setAttribute('aria-expanded', 'false');
      drawer.setAttribute('aria-hidden', 'true');
    }
    burger.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    drawer.addEventListener('click', (e) => {
      if (e.target === drawer) close();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
  }

  // « + » du rail Vestiaire (home) : popover de tailles (multi-variante) ou ajout direct (mono-variante).
  function initQuickAdd() {
    var CHECK = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12 5 5 9-11"/></svg>';

    function updateBadges(cart) {
      document.querySelectorAll('.header__badge').forEach(function (b) { b.textContent = cart.item_count; b.style.display = cart.item_count > 0 ? '' : 'none'; });
    }
    function flash(btn) {
      if (!btn) return;
      var orig = btn.getAttribute('data-orig') || btn.innerHTML;
      btn.setAttribute('data-orig', orig);
      btn.classList.add('is-added');
      btn.innerHTML = CHECK;
      setTimeout(function () { btn.classList.remove('is-added'); btn.innerHTML = orig; }, 1500);
    }
    function cartTarget() {
      var d = document.querySelector('.header__cart-desk');
      if (d && d.offsetParent !== null) return d;
      var m = document.querySelector('.header__cart');
      if (m && m.offsetParent !== null) return m;
      return d || m || document.querySelector('.header__badge');
    }
    function bumpBadge() {
      var b = (cartTarget() && cartTarget().querySelector('.header__badge')) || document.querySelector('.header__badge');
      if (!b) return;
      b.classList.remove('qw-badge-bump'); void b.offsetWidth; b.classList.add('qw-badge-bump');
    }
    function easeInOutCubic(x) { return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2; }
    function landCart(target) {
      bumpBadge();
      if (!target) return;
      target.classList.remove('qw-cart-pop'); void target.offsetWidth; target.classList.add('qw-cart-pop');
      setTimeout(function () { target.classList.remove('qw-cart-pop'); }, 540);
      var r = target.getBoundingClientRect();
      var ring = document.createElement('span');
      ring.setAttribute('aria-hidden', 'true');
      ring.style.cssText = 'position:fixed;left:' + (r.left + r.width / 2 - 16) + 'px;top:' + (r.top + r.height / 2 - 16) + 'px;width:32px;height:32px;border-radius:50%;border:2px solid var(--qw-kaki-600);z-index:9998;pointer-events:none;';
      document.body.appendChild(ring);
      if (ring.animate) {
        ring.animate([{ transform: 'scale(.45)', opacity: .6 }, { transform: 'scale(2.6)', opacity: 0 }], { duration: 580, easing: 'cubic-bezier(.2,.6,.2,1)' }).onfinish = function () { if (ring.parentNode) ring.parentNode.removeChild(ring); };
      } else { setTimeout(function () { if (ring.parentNode) ring.parentNode.removeChild(ring); }, 600); }
    }
    function flyToCart(imgEl) {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var target = cartTarget();
      if (reduce || !imgEl || !target) { bumpBadge(); return; }
      var src = imgEl.currentSrc || imgEl.src;
      if (!src) { bumpBadge(); return; }
      var s = imgEl.getBoundingClientRect(), tr = target.getBoundingClientRect();
      if (!s.width) { bumpBadge(); return; }
      var w = s.width, h = s.height, halfW = w / 2, halfH = h / 2;
      var p0 = { x: s.left + halfW, y: s.top + halfH };
      var p2 = { x: tr.left + tr.width / 2, y: tr.top + tr.height / 2 };
      var dist = Math.hypot(p2.x - p0.x, p2.y - p0.y);
      // point de contrôle au-dessus de la ligne → arc "lancer" élégant
      var ctrl = { x: (p0.x + p2.x) / 2 + (p2.x - p0.x) * 0.08, y: Math.min(p0.y, p2.y) - Math.max(90, dist * 0.34) };
      var fly = document.createElement('img');
      fly.src = src; fly.setAttribute('aria-hidden', 'true');
      fly.style.cssText = 'position:fixed;left:0;top:0;width:' + w + 'px;height:' + h + 'px;object-fit:cover;border-radius:10px;z-index:9999;pointer-events:none;box-shadow:0 16px 38px rgba(11,12,5,.32);will-change:transform,opacity;';
      document.body.appendChild(fly);
      var dur = 760, startT = 0;
      function frame(ts) {
        if (!startT) startT = ts;
        var t = Math.min(1, (ts - startT) / dur);
        var e = easeInOutCubic(t);
        var mt = 1 - e;
        var x = mt * mt * p0.x + 2 * mt * e * ctrl.x + e * e * p2.x;
        var y = mt * mt * p0.y + 2 * mt * e * ctrl.y + e * e * p2.y;
        var sc = 1 - 0.86 * Math.pow(t, 1.35);          // rétrécit en douceur (accélère vers la fin)
        var op = t < 0.74 ? 1 : Math.max(0, 1 - (t - 0.74) / 0.26);
        fly.style.transform = 'translate(' + (x - halfW) + 'px,' + (y - halfH) + 'px) scale(' + sc + ')';
        fly.style.opacity = op;
        if (t < 1) requestAnimationFrame(frame);
        else { if (fly.parentNode) fly.parentNode.removeChild(fly); landCart(target); }
      }
      requestAnimationFrame(frame);
    }
    function cardImg(el) { var c = el && el.closest('.product, .pcard-wrap'); return c && c.querySelector('.product__media img, .pcard__media img'); }
    function addVariant(id, loadBtn, flashBtn, done) {
      if (!id || (loadBtn && loadBtn.classList.contains('is-loading'))) return;
      if (loadBtn) loadBtn.classList.add('is-loading');
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: parseInt(id, 10), quantity: 1 }) })
        .then(function (r) { return r.ok ? fetch('/cart.js', { headers: { 'Accept': 'application/json' } }) : null; })
        .then(function (r) { return r ? r.json() : null; })
        .then(function (cart) {
          if (!cart) return;
          updateBadges(cart);
          flash(flashBtn);
          if (window.dataLayer && typeof window.dataLayer.push === 'function') window.dataLayer.push({ event: 'quick_add', variant_id: id });
          if (done) done();
        })
        .catch(function () {})
        .finally(function () { if (loadBtn) loadBtn.classList.remove('is-loading'); });
    }
    function closePanels(except) {
      document.querySelectorAll('[data-qa-panel]').forEach(function (p) {
        if (p === except) return;
        p.hidden = true;
        var t = p.parentElement && p.parentElement.querySelector('[data-qa-toggle]');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    }

    // ── Packs : sélecteur multi-tailles (une ligne par pièce) ──────────────────
    // Résout la variante en croisant les valeurs choisies sur les options affichées
    // (les options à valeur unique sont implicites → match auto). Retourne complétude + dispo.
    function packResolve(panel) {
      var out = { complete: false, id: null, available: false };
      var dataEl = panel.querySelector('[data-pack-variants]');
      if (!dataEl) return out;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return out; }
      var positions = {};
      panel.querySelectorAll('[data-opt-val]').forEach(function (b) { positions[b.getAttribute('data-opt-pos')] = null; });
      panel.querySelectorAll('[data-opt-val].is-active').forEach(function (b) { positions[b.getAttribute('data-opt-pos')] = b.getAttribute('data-value'); });
      for (var p in positions) { if (positions[p] === null) return out; }
      out.complete = true;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var pos in positions) { if (v.o[parseInt(pos, 10) - 1] !== positions[pos]) { ok = false; break; } }
        if (ok) { out.id = v.id; out.available = !!v.a; break; }
      }
      return out;
    }
    // Quick-add couleur→taille (rail Vestiaire) : la couleur sélectionne, la taille AJOUTE direct.
    function cqVariants(panel) {
      var s = panel.querySelector('[data-cq-variants]');
      try { return s ? JSON.parse(s.textContent) : []; } catch (err) { return []; }
    }
    function cqFind(panel, sizeVal) {
      var cBtn = panel.querySelector('[data-cq-color].is-active');
      if (!cBtn) return null;
      var cPos = parseInt(cBtn.getAttribute('data-opt-pos'), 10) - 1;
      var cVal = cBtn.getAttribute('data-value');
      var sBtn = panel.querySelector('[data-cq-size]');
      var sPos = sBtn ? parseInt(sBtn.getAttribute('data-opt-pos'), 10) - 1 : 1;
      var list = cqVariants(panel);
      for (var i = 0; i < list.length; i++) {
        if (list[i].o[cPos] === cVal && list[i].o[sPos] === sizeVal) return list[i];
      }
      return null;
    }
    function cqRefresh(panel) {
      panel.querySelectorAll('[data-cq-size]').forEach(function (sb) {
        var v = cqFind(panel, sb.getAttribute('data-value'));
        var ok = v && v.a;
        sb.classList.toggle('is-soldout', !ok);
        sb.disabled = !ok;
        if (ok) { sb.removeAttribute('aria-disabled'); } else { sb.setAttribute('aria-disabled', 'true'); }
      });
    }
    function packRefresh(panel) {
      var r = packResolve(panel);
      var btn = panel.querySelector('[data-pack-add]');
      var msg = panel.querySelector('[data-pack-msg]');
      if (btn) btn.disabled = !(r.complete && r.id && r.available);
      if (msg) {
        var soldout = r.complete && r.id && !r.available;
        msg.hidden = !soldout;
        msg.textContent = soldout ? 'Combinaison épuisée' : '';
      }
    }

    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-qa-toggle]');
      if (toggle) {
        e.preventDefault();
        var panel = toggle.parentElement.querySelector('[data-qa-panel]');
        var open = panel && panel.hidden;
        closePanels(open ? panel : null);
        if (panel) { panel.hidden = !open; toggle.setAttribute('aria-expanded', open ? 'true' : 'false'); if (open && panel.hasAttribute('data-color-qa')) cqRefresh(panel); }
        return;
      }
      var size = e.target.closest('[data-qa-add]');
      if (size) {
        e.preventDefault();
        var card = size.closest('.product, .pcard-wrap');
        var plus = card && card.querySelector('[data-qa-toggle]');
        var panel2 = size.closest('[data-qa-panel]');
        if (panel2) panel2.hidden = true;
        if (plus) plus.setAttribute('aria-expanded', 'false');
        flyToCart(cardImg(size));
        addVariant(size.getAttribute('data-variant-id'), size, plus, null);
        return;
      }
      var quick = e.target.closest('[data-qw-quick-add]');
      if (quick) {
        e.preventDefault();
        flyToCart(cardImg(quick));
        addVariant(quick.getAttribute('data-variant-id'), quick, quick, null);
        return;
      }
      // Couleur→taille : choisir une couleur (ne fait que sélectionner)
      var cqColor = e.target.closest('[data-cq-color]');
      if (cqColor) {
        e.preventDefault();
        var cqPanel = cqColor.closest('[data-color-qa]');
        if (cqPanel) {
          cqPanel.querySelectorAll('[data-cq-color]').forEach(function (btn) { btn.classList.remove('is-active'); });
          cqColor.classList.add('is-active');
          cqRefresh(cqPanel);
        }
        return;
      }
      // Couleur→taille : cliquer une taille AJOUTE immédiatement (couleur active)
      var cqSize = e.target.closest('[data-cq-size]');
      if (cqSize) {
        e.preventDefault();
        if (cqSize.disabled) return;
        var sPanel = cqSize.closest('[data-color-qa]');
        var found = sPanel ? cqFind(sPanel, cqSize.getAttribute('data-value')) : null;
        if (!found || !found.a) { if (sPanel) cqRefresh(sPanel); return; }
        var sCard = cqSize.closest('.product, .pcard-wrap');
        var sPlus = sCard && sCard.querySelector('[data-qa-toggle]');
        sPanel.hidden = true;
        if (sPlus) sPlus.setAttribute('aria-expanded', 'false');
        flyToCart(cardImg(cqSize));
        addVariant(found.id, cqSize, sPlus, null);
        return;
      }
      // Pack : sélection d'une taille dans une ligne (sélection unique par ligne)
      var optVal = e.target.closest('[data-opt-val]');
      if (optVal) {
        e.preventDefault();
        var pPanel = optVal.closest('[data-pack-qa]');
        var pPos = optVal.getAttribute('data-opt-pos');
        if (pPanel) {
          pPanel.querySelectorAll('[data-opt-val][data-opt-pos="' + pPos + '"]').forEach(function (b) { b.classList.remove('is-active'); });
          optVal.classList.add('is-active');
          packRefresh(pPanel);
        }
        return;
      }
      // Pack : bouton « Ajouter au panier » (variante résolue)
      var packAdd = e.target.closest('[data-pack-add]');
      if (packAdd) {
        e.preventDefault();
        if (packAdd.disabled) return;
        var aPanel = packAdd.closest('[data-pack-qa]');
        var res = aPanel ? packResolve(aPanel) : null;
        if (!res || !res.id || !res.available) { if (aPanel) packRefresh(aPanel); return; }
        var aToggle = aPanel.parentElement.querySelector('[data-qa-toggle]');
        aPanel.hidden = true;
        if (aToggle) aToggle.setAttribute('aria-expanded', 'false');
        flyToCart(cardImg(packAdd));
        addVariant(res.id, packAdd, aToggle, null);
        return;
      }
      if (!e.target.closest('[data-qa-panel]')) closePanels(null);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePanels(null); });
  }

  function initVestiaireRail() {
    var carousels = document.querySelectorAll('.products__carousel.is-rail');
    carousels.forEach(function (car) {
      var rail = car.querySelector('[data-rail]');
      var prev = car.querySelector('[data-rail-prev]');
      var next = car.querySelector('[data-rail-next]');
      if (!rail || !prev || !next) return;

      function step() {
        var card = rail.querySelector('.product');
        var w = card ? card.getBoundingClientRect().width : rail.clientWidth / 4;
        return Math.round((w + 20) * 2); // ~2 cartes par clic
      }
      function refresh() {
        var max = rail.scrollWidth - rail.clientWidth - 2;
        prev.hidden = rail.scrollLeft <= 2;
        next.hidden = rail.scrollLeft >= max;
      }
      prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
      rail.addEventListener('scroll', refresh, { passive: true });
      window.addEventListener('resize', refresh);
      refresh();
    });
  }

  ready(function () {
    initStickyHeader();
    initTopBar();
    initQuickAdd();
    initVestiaireRail();
    initFaqAccordion();
    initFooterAccordion();
    initPackPills();
    initNewsletter();
    initBurger();
    initJdgmApiReviews();
    initReviewForm();
    initReelsDuration();
    initReelsCarousel();
  });
})();
